module.exports = __webpack_public_path__ + "static/images/roller-blinds-video.mov";